module.exports = __webpack_public_path__ + "img/bet50.006dae40.png";